import { Inject, Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, shareReplay } from 'rxjs';
import { Environment } from '../../environment/environment.model';

interface TranscriberConfig {
  xApiKey: string;
}

@Injectable({
  providedIn: 'root',
})
export class TranscriberConfigService {
  private readonly httpClient = inject(HttpClient);
  private config$: Observable<TranscriberConfig> | undefined;

  constructor(@Inject('env') private environment: Environment) {}

  public getConfig(): Observable<TranscriberConfig> {
    if (!this.config$) {
      this.config$ = this.httpClient
        .get<TranscriberConfig>(`${this.environment.apiUrl}/config/transcriber`)
        .pipe(shareReplay(1));
    }
    return this.config$;
  }
}
